import { useState, useEffect } from 'react';

function useBoundingClientRect<T extends HTMLElement>(): [DOMRect | undefined, (t: T | null) => void] {
  const [element, setElement] = useState<T | null>()
  const [rect, setRect] = useState<DOMRect>();

  useEffect(() => {

    const updateRect = () => {
      if (element) {
        setRect(element.getBoundingClientRect());
      }
    }

    updateRect();

    window.addEventListener('resize', updateRect);

    const observer = new ResizeObserver(updateRect);
    if (element) {
      observer.observe(element);
    }

    return () => {
      window.removeEventListener('resize', updateRect);
      observer.disconnect();
    };
  }, [element]);

  return [rect, setElement];
}

export default useBoundingClientRect;
